import { css } from '@emotion/react'

import { rgba } from 'polished'

import { colors, weights, transitions } from '@/styles/theme'
import { mediaDown, mediaUp } from '@/styles/media'
import { Text2Styles } from '@/styles/typography'
import { focusVisible, underline, underlineHover } from '@/styles/mixins'

export const linksList = css`
  position: relative;
  list-style: none;
  display: flex;
  align-items: center;
  ${mediaDown('lg')} {
    margin: 82px 0;
    flex: 1;
    flex-direction: column;
    overflow: auto;
  }
`

export const linksListItem = css`
  margin: 9px 0;
  ${mediaUp('lg')} {
    margin-inline-start: 30px;
    margin-top: 0;
    margin-bottom: 0;
  }
`

export const linksListItemWithDropdown = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const linkItem = css`
  ${focusVisible};
  ${Text2Styles};
  ${underlineHover};
  color: #0b4684;
  cursor: pointer;
  display: flex;
  align-items: center;
  ${mediaDown('lg')} {
    font-weight: ${weights.black};
    font-size: 18px;
    line-height: 1.44;
    color: ${colors.white};
  }
`

export const linkItemActive = css`
  ${underline};
`

export const link = { linkItem, linkItemActive }

export const dropdownIcon = css`
  margin-inline-start: 4px;
  transition: transform ${transitions.base};
  transform: rotate(0);
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  > path {
    fill: ${colors.white};
  }
  ${mediaUp('lg')} {
    > path {
      fill: var(--main);
    }
  }
`

export const dropdownIconActive = css`
  transform: rotate(180deg);
`

export const callUsContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const callUsTitle = css`
  font-weight: 700;
  font-size: 12px;
  color: #0b4684;
`

export const callUsNumber = css`
  font-weight: 700;
  font-size: 16px;
  color: #1574e0;
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const onlyDesktop = css`
  ${mediaDown('lg')} {
    display: none;
  }
`

export const onlyMobile = css`
  ${mediaUp('lg')} {
    display: none;
  }
`

export const iconContainer = css`
  height: 25px;
  aspect-ratio: 1;
  background-color: ${colors.white};
  box-shadow: 0px 4px 24px 0px ${rgba(colors.twilightBlue, 0.14)};
  margin-left: 7.5px;
  display: flex;
  border-radius: 99px;
`

export const iconLink = css`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`
